<app-filter class="filterBox" [name]="name"(selectedFilter)="handleSelectedFilter($event)" (selectedHeader)="getPromoData($event)"></app-filter>